var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('events.view.presenter'))?_c('button',{staticClass:"btn btn-fill btn-wd btn-pptx btn-block btn-router",on:{"click":function($event){return _vm.download()}}},[_vm._v("\n  PPT Clientes Reservas\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faa4acac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Events/Actions/BtnDownloadPptxSubstituteCustomers.vue
// module id = DzKl
// module chunks = 10